export const DOCUMENTO_RECURRENTE_INTERVALO = {
  DIARIO: 1,
  SEMANAL: 7,
  QUINCENAL: 15,
  MENSUAL: 30,
  BIMESTRAL: 60,
  TRIMESTRAL: 90,
  SEMESTRAL: 180,
  ANUAL: 365,
} as const

export type DocumentoRecurrenteIntervaloType =
  (typeof DOCUMENTO_RECURRENTE_INTERVALO)[keyof typeof DOCUMENTO_RECURRENTE_INTERVALO]
